import service from '@/utils/request'; 
export default {
    ws: {},
    setWs: function(newWs) {
        this.ws = newWs
    },
    start(){// 发送心跳
        clearInterval(this.timeoutObj)
        this.timeoutObj = setInterval(() => {
            if (this.ws && this.ws.readyState == 1) {
                console.log('发送心跳')
                this.ws.send(JSON.stringify({
                    //后端需要接收的数据
                }));
            }
        }, 10 *1000)//十秒发一次
    },
    localSocket(userId,url) {//连接ws，根据连接服务器是否需要参数设置该方法是否需要接收参数
        if ("WebSocket" in window) {
            // console.log("您的浏览器支持 WebSocket!");
            // location.host
            this.ws = new WebSocket(url)
            this.setWs(this.ws);
            this.ws.onopen = ()=>{
                console.log('websocket连接成功了...');
                //连接上之后要发心跳包
                //this.start()
            };
            this.ws.onclose = function () {
                // 关闭 websocket
                console.log("连接已关闭...");
                //断线重新连接
                setTimeout(() => {
                    this.localSocket(userId,url)
                }, 2000);
            };
        } else {
            // 浏览器不支持 WebSocket
            console.log("您的浏览器不支持 WebSocket!");
        
        }
    },
    /**
   * 通用获取表单列配置
   * @param {Object} config - 查询配置
   * @param {String} config.table - 表名 (默认 v_sys_form_fld)
   * @param {Object} config.keys - 键值对 { p_key: 'idseq', p_value: '400038', ... }
   * @param {String} config.orderBy - 排序条件 (默认 order by sortby,lstseq)
   * @param {Function} customMapper - 可选的自定义映射函数，若不传则使用默认映射
   */
  fetchFormColumns(config = {}) {
    const {
      table = 'v_sys_form_fld',
      keys = {},
      orderBy = 'order by sortby,lstseq',
      v_lang ='',
      v_url = 'xuper_auth/getBaseData'
    } = config;

    // 构建请求参数
    const params = {
      p_table: table,
      p_cond: orderBy,
      ...keys // 展开传入的键值对，如 p_key, p_value 等
    };

    return  service.post(v_url, params).then(res => {
      if (!res.result || !Array.isArray(res.result)) {
        console.warn('未获取到有效的列数据');
        return [];
      }
 
      // 清空当前列并重新赋值（根据你原有逻辑是 push，建议先清空或按需追加）
      const newCols = res.result.map((item ) => {
        let title = item.title;
          if (v_lang === 'EN' && item.FLDEN) title = item.FLDEN;
          else if (v_lang === 'YN' && item.FLDYN) title = item.FLDYN;

          return {
            title: title,
            key: item.key,
            align: item.align,
            width: item.width,
            thide: item.THIDE,
            fhide: item.FHIDE,
            edcss: item.EDCSS,
            disabled: item.DISABLED,
            dotnum: item.DOTNUM,
            sortable: item.SORTABLE
          };
      } )
      return newCols
    }).catch(err => {
      console.error('获取列配置失败:', err)
      return [];
    });
  },

  
} 